import { CloudIcon } from "@heroicons/react/solid";
import * as React from "react";
import type { CSS } from "~/config/stitches";
import { styled } from "~/config/stitches";
import { Icon } from "../../Icon";
import type { IconProps } from "../../Icon/Icon";
import type { FolderIconProps } from "../FolderIcon";

const FolderIconCloudWrapper = styled("div", {
  backgroundColor: "$white",
  borderRadius: "50% 50% 0 0",
  bottom: 0,
  position: "absolute",
  right: 0,
});

type FolderIconCloudProps = Pick<FolderIconProps, "size"> & {
  css?: CSS;
  color: IconProps["color"];
};

const FolderIconCloud = (props: FolderIconCloudProps) => {
  const iconSizeByFolderSize = {
    large: "xsmall",
    medium: "xxsmall",
    small: "xxsmall",
    xlarge: "small",
  } as const;

  return (
    <FolderIconCloudWrapper>
      <Icon
        label={`cloud`}
        size={iconSizeByFolderSize[props.size]}
        color={props.color}
        css={props.css}
      >
        <CloudIcon />
      </Icon>
    </FolderIconCloudWrapper>
  );
};

export { FolderIconCloud };
